// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"c9d526c3","374":"799e9c92","551":"535b75d8","567":"b8b4b129"}[chunkId] + ".chunk.js";
};